import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10","key":"svg-0"}],["path",{"d":"M3 17l4 -3h10l4 3","key":"svg-1"}],["path",{"d":"M7 9.5a.5 .5 0 1 0 1 0a.5 .5 0 1 0 -1 0","fill":"currentColor","key":"svg-2"}],["path",{"d":"M16 9.5a.5 .5 0 1 0 1 0a.5 .5 0 1 0 -1 0","fill":"currentColor","key":"svg-3"}]]

const IconDeviceAudioTape = createReactComponent('outline', 'device-audio-tape', 'DeviceAudioTape', __iconNode);

export default IconDeviceAudioTape;